import { Stance, StanceFilter } from '@sweetspot/shared/types'

export const RangeStanceFilterMap = {
  [Stance.BOTH]: StanceFilter.RightAndLeftHanded,
  [Stance.RIGHT]: StanceFilter.RightHanded,
  [Stance.LEFT]: StanceFilter.LeftHanded,
}
